export default "__VITE_ASSET__BxZwgCKx__"